import exchange from "../exchange"
import pointList from "../items/point_list"
import pointJournalList from "../items/point_journal_list"
import giftList from "../items/gift_list"
import exchangeOrderList from "../items/exchange_order_list"


export default {
	path:'exchange',
	name:'exchange',
	component:exchange,
	children:[
		{
			path:'student/point/list',
			name:'student-point-list',
			component:pointList
		},
		{
			path:'student/point/journal/list',
			name:'student-point-journal-list',
			component:pointJournalList
		},
		{
			path:'gift/list',
			name:'gift-list',
			component:giftList
		},
		{
			path:'order/list',
			name:'order-list',
			component:exchangeOrderList
		},
	]
}